import type { IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputTextDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        ngModel: "=",
    };

    public template: string;

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    constructor() {
        this.template = `
            <input type="text" aa-field-group="ngModel" aa-label="{{irLabel | translate}}"/>
        `;
    }
}

module("mmGui").directive("irInputText", () => new InputTextDirective());
